import { useEffect, useState } from "react";
import RadioListing from "../../RadioListing";

import { getLabel } from "../../../hooks/use-labels";

import { fetchSavedCards } from "./api-handler";
import LabelItem from "../components/LabelItem";
import BankCardImage from "../assets/bank-card.svg";
import { filterSavedCardsByCurrency } from "../payment-process-utils";

const SavedCards = (props) => {
  const [savedCards, setSavedCards] = useState([]);
  const { methodDetails, onChange, currency } = props;

  useEffect(() => {
    fetchSavedCards()
      .then(({ data }) => {
        const authorizations = filterSavedCardsByCurrency(
          data.authorizations,
          currency
        );
        const cards = authorizations.map(({ id, bin, last4 }) => ({
          id,
          label: (
            <LabelItem
              title={getLabel("bankCardLabel")}
              subTitle={`${bin} ${last4}`.replace(" ", "******")}
            />
          ),
          value: id,
          imgSrc: BankCardImage,
        }));

        setSavedCards(cards);
      })
      .catch(console.error);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeOption = ({ target }) => {
    const savedCardInfo = {
      authId: target.value,
      amount: props.amount,
      description: props.description,
      purpose: props.purpose,
    };

    onChange({ ...savedCardInfo, method: "SAVED_CARDS" });
  };

  if (!savedCards.length) return null;

  return (
    <div>
      <RadioListing
        options={savedCards}
        className="payment-radio-listing"
        value={methodDetails.authId}
        onChange={onChangeOption}
        labelClass={"align-start"}
      />
    </div>
  );
};

export default SavedCards;
